import styles from "../Notification/Notification.module.css";

export default function Notification() {
    return <p className={styles.message}>No feedback yet</p>;
}
